import React from 'react';
import { Globe, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  const navigate = useNavigate();
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <Globe className="h-8 w-8 text-brand-teal" />
          <h1 className="text-3xl font-bold text-brand-teal">Sobre Nós</h1>
        </div>
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors"
        >
          <Home className="h-4 w-4" />
          <span>Voltar para Home</span>
        </button>
      </div>

      <div className="grid gap-8">
        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Nossa História</h2>
          <p className="text-gray-600 mb-4">
            A Igreja Sal da Terra em Brasília nasceu do desejo de impactar a capital do país
            com o evangelho de Jesus Cristo. Desde nossa fundação, temos sido uma comunidade
            comprometida com a Palavra de Deus e com a transformação de vidas.
          </p>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Nossa Visão</h2>
          <p className="text-gray-600 mb-4">
            Ser uma igreja que impacta Brasília e o Brasil com o evangelho, formando discípulos
            de Jesus Cristo e transformando vidas através do poder da Palavra de Deus.
          </p>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Nossos Valores</h2>
          <div className="grid gap-4">
            <div className="p-4 bg-brand-light rounded-lg">
              <h3 className="font-semibold text-brand-teal mb-2">Palavra de Deus</h3>
              <p className="text-gray-600">Comprometimento com o ensino e prática da Palavra.</p>
            </div>
            <div className="p-4 bg-brand-light rounded-lg">
              <h3 className="font-semibold text-brand-teal mb-2">Família</h3>
              <p className="text-gray-600">Valorização e fortalecimento das famílias.</p>
            </div>
            <div className="p-4 bg-brand-light rounded-lg">
              <h3 className="font-semibold text-brand-teal mb-2">Comunhão</h3>
              <p className="text-gray-600">Relacionamentos genuínos e acolhedores.</p>
            </div>
          </div>
        </section>

        <section className="bg-white p-8 rounded-xl shadow-sm">
          <h2 className="text-2xl font-semibold text-brand-teal mb-4">Localização</h2>
          <p className="text-gray-600 mb-4">
            Endereço da igreja e horários dos cultos
          </p>
          <div className="aspect-video w-full bg-gray-200 rounded-lg">
            {/* Aqui você pode adicionar um mapa do Google Maps */}
          </div>
        </section>
      </div>
    </div>
  );
}